// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__39uqN","notes":"Notes_notes__4JHij"};